// extracted by mini-css-extract-plugin
export default {"td":"BmaPontoIndex_td__mJX0-"};